/**
 * Created by Ning Jiang on 2021-05-07.
 */

export class MathHelper {
    private static prevUniqueNum: number;

    public static randomNumberInRange(min: number, max: number, decimals: number = 0): number {
        let randomNumber: number = min + (max - min) * Math.random();
        return Number(randomNumber.toFixed(decimals));
    }

    public static roundToDecimals(num: number, noOfDecimals: number): number {
        return Number((num).toFixed(noOfDecimals));
    }

    public static uniqueNumberInRange(min: number, max: number, decimals: number = 0): number {
        if ((min === max) || (min > max)) { //min > max condition added because of blank array and it's length - 1
            return min;
        } else {
            let randomNumber: number = Number((min + (max - min) * Math.random()).toFixed(decimals));
            if (this.prevUniqueNum === randomNumber) {
                randomNumber = this.uniqueNumberInRange(min, max, decimals);
            }
            this.prevUniqueNum = randomNumber;
            return randomNumber;
        }
    }

    public static getTimeStamp(): string {
        const today: Date = new Date(),
            timeStr: string = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds() + ":" + today.getMilliseconds();
        return timeStr;
    }
}